module.exports = __webpack_public_path__ + "img/home.06d6878a.png";